import { render, staticRenderFns } from "./msGridEditorV2.vue?vue&type=template&id=66bce404&scoped=true"
import script from "./msGridEditorV2.vue?vue&type=script&lang=js"
export * from "./msGridEditorV2.vue?vue&type=script&lang=js"
import style0 from "./msGridEditorV2.vue?vue&type=style&index=0&id=66bce404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bce404",
  null
  
)

export default component.exports